import { render, staticRenderFns } from "./tryLeason.vue?vue&type=template&id=0647f3a5&scoped=true&"
import script from "./tryLeason.vue?vue&type=script&lang=js&"
export * from "./tryLeason.vue?vue&type=script&lang=js&"
import style0 from "./tryLeason.vue?vue&type=style&index=0&id=0647f3a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647f3a5",
  null
  
)

export default component.exports